import api from "../services/api"
import { registerEmailInKlaviyo } from "../services/klaviyo"
import { getLang } from "../utils/get-lang"
import { mediaQuery } from "../utils/media-query"
import { $Q, $Qll } from "../utils/query-selector"
import { addNodeSpinner } from "../utils/spinner"
import { toggleDataActive } from "../utils/toggle-dataset"
import { ItemAlert, renderQtyAlert } from "./mes-alerts-account"
import { buildObject, cleanInputs } from "./plus-photo"

export const initializeMesAlertsMethods = (id) => {
  toggleDataActive('#js-btn-mes-alets-open', '#js-mes-alerts-modal', {
    overlay: true,
    closeSelector: '#js-mes-alerts-modal-close',
    blockScroll: true,
    cb: resetFormElements
  });

  assignModels(id)
  mesAlertsSubmit()
}

/**
 * Function used like call back in toggle-dataset to run custom features
 * @param {boolean} status - Toggle status
 */
export const resetFormElements = (status, id) => {
  if (!status) {

    cleanInputs(
      $Qll(`#js-mes-alerts${id ? `-${id}` : ''}-form select`),
      $Q(`#js-mes-alerts${id ? `-${id}` : ''}-form button[type="submit"]`)
    )

    manageCssClass({
      element: $Q(`.models-select${id ? `-${id}` : ''}`),
      cssClass: 'models-enable',
      typeAction: 'remove'
    })

    manageCssClass({
      element: $Q(`#js-mes-alerts${id ? `-${id}` : ''}-form`),
      cssClass: 'hidden',
      typeAction: 'remove'
    })
    const header = $Q('.js-header')

    if (header) {
      header.removeAttribute('style')
    }

    resetModelsSelect(id)
    cleanMessage()
  }

  if (status) {
    const subtmitBtn = $Q(`#js-mes-alerts${id ? `-${id}` : ''}-form button[type="submit"]`)
    const header = $Q('.js-header')

    if (header) {
      header.style.zIndex = '2'
    }

    if (subtmitBtn) subtmitBtn.disabled = true
  }
}

/**
 * Designer feature
 * Create models select
 */

/**
 * Remove modesl options of the DOM
 * @returns null - stop called
 */
const resetModelsSelect = (id) => {
  const modelSelect = $Q(`#js-mes-alerts${id ? `-${id}` : ''}-model`)

  if (!modelSelect) return

  modelSelect.innerHTML = ''
}

/**
 * Manage custom toggle
 * @param {node} element - Node to add or remove css Class
 * @param {string} cssClass -  Css class to interactive
 * @param {string} typeAction - What action do - add or remove
 * @returns null - stop called
 */
export const manageCssClass = ({
  element,
  cssClass,
  typeAction = 'add'
}) => {
  if (!element) return;

  if (typeAction === 'remove' && element.classList.contains(cssClass))
    element.classList.remove(cssClass)
  else if(typeAction === 'add' && !element.classList.contains(cssClass))
    element.classList.add(cssClass)
}

/**
 * Array with the models of desiganer choses
 * @param {array} array
 * @returns array - Array with nodes like string to render
 */
const buildOptions = (array, modelText) => {
  if (!array.length) return

  /**
   * If there are more than 128 items, the last items will have the anothers items separete with "|"
   * And here structure that items and add to main array
   */
  if (array.length === 128) {
    const moreItems = array.pop()
    array.push(...moreItems.split('|'))
  }

  const arrayOptions = array.map((item) => {
    const itemParsed = item.includes('#') ? item.replace(/([#?])+/g, "'") : item;
    return `<option value="${itemParsed.toLowerCase()}">${itemParsed}</option>`
  })

  arrayOptions.unshift(`<option value="" selected>${modelText ? modelText : 'Modèle'}</option>`)

  return arrayOptions.join('')
}

export const fillSelect = (optionName, select, id) => {
  const optionSelected = $Q(`option[value="${optionName}"]`, select)
  const optionsModels = optionSelected && optionSelected.dataset.models
  const modelText = optionSelected && optionSelected.dataset.modelWord
  const modelSelect = $Q(`#js-mes-alerts${id ? `-${id}` : ''}-model`)


  if (!optionsModels && modelSelect) return

  modelSelect.innerHTML = buildOptions(JSON.parse(optionsModels), modelText)
  manageCssClass({
    element: $Q(`.models-select${id ? `-${id}` : ''}`),
    cssClass: 'models-enable'
  })
}

/**
 * Liste input event
 * Get options built
 * Render models select in form
 */
export const assignModels = (id) => {
  const designersSelect = $Q(`#js-mes-alerts${id ? `-${id}` : ''}-brand`)

  designersSelect && designersSelect.addEventListener('input', (e) => {
    const value = e.target.value

    if (!value) return
    fillSelect(value, e.target, id)
  })
}




/**
 * Send data functions
 */


/**
 * If some select is choose, enable button
 * @param {object} e - input event
 * @returns null - stop called
 * @see listenSelectAndActiveForm
 */
const activeForm = (e, id) => {
  if (e.target.value || e.target.value === '') {
    const formBtn = $Q(`#js-mes-alerts${id ? `-${id}` : ''}-form button[type="submit"]`)

    if (!formBtn) return;

    formBtn.disabled = false
  }
}

/**
 * Listens inputs to active button form
 * @returns null - stop called
 */
const listenSelectAndActiveForm = (id) => {
  const selects = $Qll(`#js-mes-alerts${id ? `-${id}` : ''}-form select`)

  if (!selects.length) return;

  selects.forEach((select) => select.addEventListener('input', (e) => {
    activeForm(e, id)
  }))
}

/**
 * Validate if there is at lest one element
 * Validate if the select designer have value, the user must choose a model
 * @param {object} payload - structure to send to the API
 * @returns object - the same structure to API response
 */
export const validateSelects = (payload) => {
  const validated = Object.values(payload)

  if (validated.length < 1) {
    return { message: '1' }
  }

  if (payload['designer'] && !payload['model']) {
    return { message: 'model' }
  }

  return false
}

/**
 * Render feedbackComppnent and add response text
 * @param {node} element - element to render and put text
 * @param {string} action - Define is remove or add class
 * @param {string} text -  Text to add to the component
 */
const renderComponent = (element, action, text, error) => {
  manageCssClass({
    element,
    cssClass: 'hidden',
    typeAction: action
  })

  element.innerHTML = text
}

/**
 * Clear all message rendered
 * @returns null - stop called
 */
export const cleanMessage = () => {
  const message = $Qll('.form__message')

  if (!message.length) return

  message.forEach((el) => !el.classList.contains('hidden') && el.classList.add('hidden'))

  const descriptionItem = $Q('#js-mes-alerts-modal .description-modal__description')

  if (descriptionItem) descriptionItem.classList.contains('hidden') && descriptionItem.classList.remove('hidden')

  const titleItem = $Q('#js-mes-alerts-modal .description-modal__title')

  if (titleItem) titleItem.classList.contains('hidden') && titleItem.classList.remove('hidden')
}

/**
 * Clear all message rendered with delay
 * @returns null - stop called
 */
export const cleanDelayMessage = () => {
  setTimeout(() =>{
    cleanMessage()
  }, 2000)
}

/**
 * Validate cases of response to user
 * User must choose at lest one input
 * If user choses designer you must choose model
 * General error
 * And success case
 * @param {string} message - variable to validate cases to render feedback
 * @see renderComponent
  * @returns null - stop called
 */
const renderFeedback = (message, id) => {
  let validation = false;
  const errorContainer = $Q(`#js-mes-alerts${id ? `-${id}` : ''}-response-error`)
  const successContainer = $Q(`#js-mes-alerts${id ? `-${id}` : ''}-response`)
  const form = $Q(`#js-mes-alerts${id ? `-${id}` : ''}-form`)

  switch(message) {
    case '1' : // User must choose at lest one input
      if (!errorContainer) return;

      renderComponent(
        errorContainer,
        'remove',
        `${window.icons.iconError} ${errorContainer.dataset.textResponseMinimumOneError}`
        )
      validation = true
      break;
    case 'model' : // If user choses designer, user must choose model
      const modelErrorContainer = $Q(`#js-mes-alerts${id ? `-${id}` : ''}-response-model-error`)

      if (!modelErrorContainer) return;

      manageCssClass({
        element: modelErrorContainer,
        cssClass: 'hidden',
        typeAction: 'remove'
      })

      validation = true
      break
    case 'Alert created correctly' :
      if (!successContainer) return;

      manageCssClass({
        element: successContainer,
        cssClass: 'hidden',
        typeAction: 'remove'
      })

      manageCssClass({
        element: form,
        cssClass: 'hidden',
        typeAction: 'add'
      })

      manageCssClass({
        element: $Q('#js-mes-alerts-modal .description-modal__description'),
        cssClass: 'hidden',
        typeAction: 'add'
      })

      manageCssClass({
        element: $Q('#js-mes-alerts-modal .description-modal__title'),
        cssClass: 'hidden',
        typeAction: 'add'
      })

      validation = true
      break
    case 'No more alerts can be added':
      renderComponent(
        errorContainer,
        'remove',
        `${window.icons.iconError} ${errorContainer.dataset.textResponseLimitAlertsError}`
        )
      validation = true
      break
    default:
      if (!errorContainer) return;

      renderComponent(
        errorContainer,
        'remove',
        `${window.icons.iconError} ${errorContainer.dataset.textResponseError}`)
      break
  }

  return validation
}

/**
 * Enable button after add spinner
 * @param {node} submitBtn - button node
 */
export const activeButon = (submitBtn) => {
  submitBtn.innerHTML = submitBtn.dataset.text;
  submitBtn.disabled = false
}

const renderNewAlertsInAccount = async () => {
  const mesAlertsAccount = $Q('mes-alerts-account')
  const contentItems = $Q('#js-mes-alerts-items', mesAlertsAccount)
  const contentElement = $Q('#js-mes-alerts-content', mesAlertsAccount)
  const emptyState = $Q('#js-mes-alerts-empty-state')

  if (!mesAlertsAccount) return

  try {
    const data = await api.getDataVintegaAPI({
      url: `/customers/${mesAlertsAccount.dataset.customerId}/alerts`
    })

    if (!data.length) {
      return
    } else {
      manageCssClass({
        element: mesAlertsAccount,
        cssClass: 'hidden',
        typeAction: 'remove'
      })

      manageCssClass({
        element: emptyState,
        cssClass: 'hidden',
        typeAction: 'add'
      })
    }
    // Clean node
    contentItems.innerHTML = ''

    data.forEach((item) => {
      item.customerId = mesAlertsAccount.dataset.customerId
      item.textsComponent = JSON.parse(mesAlertsAccount.dataset.textsComponent)
      contentItems.append(new ItemAlert(item, contentElement))
    })

    renderQtyAlert($Q('#js-mes-alerts-account-qty'), data.length ? data.length : 0)
  } catch(error) {
    console.error({ error })
  }
}

/**
 * Create alert and render feedback
 * @param {string} customerId - Customer id
 * @param {object} payload - Objecto to send
 * @param {node} submitBtn - Submitter
 * @returns {string} response request
 */
const callBackMesAlertSubmit = async (customerId, payload, submitBtn) => {
  const { message } = await api.sendDataVintegaAPI({
    url: `/customers/${customerId}/alerts`,
    payload
  })

  // Here render messages: Your alert was create correctly
  renderFeedback(message)
  activeButon(submitBtn)

  // This function will run is the user is in account page
  renderNewAlertsInAccount()
  return message
}


/**
 * Add lang properties to payload before to send to request
 * @param {node} form
 * @param {string} typeInput
 * @param {object} payload
 */
const buildLangObject = (form, typeInput, payload) => {
  const inputs = $Qll(typeInput, form).length && $Qll(typeInput, form)

  for (let index = 0; index < inputs.length; index++) {
    const element = inputs[index];

    if (element.value) {
      payload[`lang_${element.name}`] =
        $Q(`option[value="${element.value}"]`, element)
          .textContent
          .trim()
          .toLocaleLowerCase()
    }
  }
}

/**
 * Listen submit event
 * Add loader spinner to button
 * Get data structured
 * Validate fields and render feedback messages
 * Resquest to create alert
 * Manage errores
 * @param {function} cb - Callback with custom request and manage response
 * @returns null - stop called
 */
export const mesAlertsSubmit = (cb = callBackMesAlertSubmit, id) => {
  const form = $Q(`#js-mes-alerts${id ? `-${id}` : ''}-form`)
  const submitBtn = $Q(`#js-mes-alerts${id ? `-${id}` : ''}-form button[type="submit"]`)

  if (!form) return

  const userEmail = submitBtn.dataset.userEmail
  listenSelectAndActiveForm(id)

  form.addEventListener('submit', async (e) => {
    e.preventDefault()

    try {
      submitBtn.disabled = true
      addNodeSpinner(submitBtn);

      const payload = buildObject(e.target, 'select')
      buildLangObject(e.target, 'select', payload)
      console.log({ payload })
      const { message: messageValidationsSelects } = validateSelects(payload)
      const boolFeedback = messageValidationsSelects ? renderFeedback(messageValidationsSelects, id) : null

      if (boolFeedback) {
        cleanDelayMessage()
        activeButon(submitBtn)
        return null
      }

      getLang(userEmail)
      await cb(form.dataset.customerId, payload, submitBtn)
    } catch(error) {
      console.log({ error })
      // Here render message genera: Something is bad, please choose at lest one option or try agan.
      renderFeedback(error.response.data.message, id)
      cleanDelayMessage()
      activeButon(submitBtn)
    }
  })
}
